// import React, { useState, useContext } from 'react';//, useEffect
// import DepositCss from '../css/DepositCss';
// import { useNavigate } from 'react-router-dom';
// import { Context } from '../Context/Context';
// import { Flip, toast } from 'react-toastify';
// import { DeleteJantriApi } from '../Api/DeleteJantri';
// import { Helmet } from 'react-helmet';
// export default function DeleteJantri() {

//     const [selectedClient, setSelectedClient] = useState('');
//     const [selectedGame, setSelectedGame] = useState('');

//     const navigate = useNavigate();
//     const { setLoad, setLoadColor, sessionDetail } = useContext(Context);

//     const handleDelete = async () => {
//         if (!selectedClient || !selectedGame) {
//             toast.error("Please select both client and game", {
//                 position: "top-right",
//                 autoClose: 1500,
//                 theme: "colored",
//                 transition: Flip,
//             });
//             return;
//         }

//         setLoad(true);
//         setLoadColor("#ff4d4d");

//         const requestData = {
//             username: JSON.parse(localStorage.getItem('userinfo'))?.username,
//             client_name: selectedClient,
//             game_name: selectedGame,
//             user_id: JSON.parse(localStorage.getItem('userinfo'))?.userId
//         };

//         try {
//             console.log("Deleting Jantri for:", requestData);
//             const res = await DeleteJantriApi(requestData);
//             if (res.data.status) {
//                 toast.success("Jantri deleted successfully!", {
//                     position: "top-right",
//                     autoClose: 3000,
//                     theme: "colored",
//                     transition: Flip,
//                 });

//                 navigate("/game");
//             } else {
//                 toast.error(res.data.message, {
//                     position: "top-right",
//                     autoClose: 2000,
//                     theme: "colored",
//                     transition: Flip,
//                 });
//             }
//         } catch (error) {
//             toast.error("Failed to delete Jantri", {
//                 position: "top-right",
//                 autoClose: 2000,
//                 theme: "colored",
//                 transition: Flip,
//             });
//         } finally {
//             setLoad(false);
//         }
//     };

//     return (
//         <DepositCss>
//             <Helmet>
//                 {/* Page Title */}
//                 <title>Delete Jantri | Remove Jantri Records | Matka Jantri</title>

//                 {/* SEO Description */}
//                 <meta
//                     name="description"
//                     content="Delete Jantri records securely and manage your Matka satta data efficiently. Remove outdated or incorrect jantri entries easily on MatkaJantri."
//                 />

//                 {/* SEO Directives */}
//                 <meta name="robots" content="noindex, nofollow" />

//                 {/* Canonical URL */}
//                 <link rel="canonical" href="https://pushpabetfair.com/delete-jantri" />

//                 {/* Favicon and Icons */}
//                 <link rel="icon" href="/favicon.ico" type="image/x-icon" />
//                 <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
//                 <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
//                 <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />

//                 {/* Mobile Optimization */}
//                 <meta name="viewport" content="width=device-width, initial-scale=1.0" />

//                 {/* Open Graph */}
//                 <meta property="og:title" content="Delete Jantri | Remove Jantri Records | MatkaJantri" />
//                 <meta
//                     property="og:description"
//                     content="Delete Jantri records securely and manage your Matka satta data efficiently. Remove outdated or incorrect jantri entries easily on MatkaJantri."
//                 />
//                 <meta property="og:type" content="website" />
//                 <meta property="og:url" content="https://pushpabetfair.com/delete-jantri" />
//                 <meta property="og:image" content="https://app.matkajantri.com/JantriImage/Logo.png" />
//             </Helmet>

//             <div className="w-100 fullpage">
//                 <div className="w-3">
//                     <div className="back-top">
//                         <i className="fa-solid fa-chevron-left" onClick={() => navigate("/game")}></i>
//                     </div>
//                     <div className="w-100 text-center d-flex">
//                         <button className="addFunds">
//                             <i className="fa-solid fa-trash"></i> Delete Jantri
//                         </button>
//                     </div>

//                     <div className="w-100 px-3">
//                         {/* Select Client */}
//                         <div className="mb-3 w-100">
//                             <label className="form-label">Select Client <span style={{ color: 'red' }}>*</span></label>
//                             <select
//                                 className="form-control"
//                                 value={selectedClient}
//                                 onChange={(e) => setSelectedClient(e.target.value)}
//                             >
//                                 <option value="">-- Select Client --</option>
//                                 {sessionDetail?.user_clients?.map((client, index) => (
//                                     <option key={index} value={client} >{client}</option>
//                                 ))}
//                             </select>
//                         </div>

//                         {/* Select Game */}
//                         <div className="mb-3 w-100">
//                             <label className="form-label">Select Game <span style={{ color: 'red' }}>*</span></label>
//                             <select
//                                 className="form-control"
//                                 value={selectedGame}
//                                 onChange={(e) => setSelectedGame(e.target.value)}
//                             >
//                                 <option value="">-- Select Game --</option>
//                                 {sessionDetail?.user_games?.map((games, index) => (
//                                     <option key={index} value={games}>{games}</option>
//                                 ))}
//                             </select>
//                         </div>

//                         <div className="text-center">
//                             <button className="submit-btn support-btn" onClick={handleDelete}>
//                                 Delete Jantri
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </DepositCss>
//     );
// }


import React, { useState, useContext } from 'react';
import DepositCss from '../css/DepositCss';
import { useNavigate } from 'react-router-dom';
import { Context } from '../Context/Context';
import { Flip, toast } from 'react-toastify';
import { DeleteJantriApi } from '../Api/DeleteJantri';
import { Helmet } from 'react-helmet';

export default function DeleteJantri() {

    const [selectedClient, setSelectedClient] = useState('');
    const [selectedGame, setSelectedGame] = useState('');
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

    const navigate = useNavigate();

    const {
        setLoad,
        setLoadColor,
        sessionDetail
    } = useContext(Context);


    // =========================================================
    // Actual Delete API Call
    // =========================================================
    const performDelete = async () => {

        setShowDeleteConfirm(false);

        setLoad(true);
        setLoadColor("#ff4d4d");

        const userInfo = JSON.parse(
            localStorage.getItem('userinfo')
        );

        const requestData = {
            username: userInfo?.username,
            client_name: selectedClient,
            game_name: selectedGame,
            user_id: userInfo?.userId
        };

        try {

            console.log(
                "Deleting Jantri for:",
                requestData
            );

            const res = await DeleteJantriApi(requestData);

            if (res.data.status) {

                toast.success(
                    "Jantri deleted successfully!",
                    {
                        position: "top-right",
                        autoClose: 3000,
                        theme: "colored",
                        transition: Flip,
                    }
                );

                navigate("/game");

            } else {

                toast.error(
                    res.data.message,
                    {
                        position: "top-right",
                        autoClose: 2000,
                        theme: "colored",
                        transition: Flip,
                    }
                );
            }

        } catch (error) {

            console.error(
                "Delete Jantri error:",
                error
            );

            toast.error(
                "Failed to delete Jantri",
                {
                    position: "top-right",
                    autoClose: 2000,
                    theme: "colored",
                    transition: Flip,
                }
            );

        } finally {

            setLoad(false);
        }
    };


    // =========================================================
    // Delete Button
    // =========================================================
    const handleDelete = () => {

        if (!selectedClient || !selectedGame) {

            toast.error(
                "Please select both client and game",
                {
                    position: "top-right",
                    autoClose: 1500,
                    theme: "colored",
                    transition: Flip,
                }
            );

            return;
        }


        // -----------------------------------------------------
        // Show custom confirmation when everything is selected
        // -----------------------------------------------------
        if (
            selectedClient === "All Clients" &&
            selectedGame === "All Games"
        ) {

            setShowDeleteConfirm(true);

            return;
        }


        // -----------------------------------------------------
        // Normal delete
        // -----------------------------------------------------
        performDelete();
    };


    return (
        <DepositCss>

            <Helmet>

                <title>
                    Delete Jantri | Remove Jantri Records | Matka Jantri
                </title>

                <meta
                    name="description"
                    content="Delete Jantri records securely and manage your Matka satta data efficiently. Remove outdated or incorrect jantri entries easily on MatkaJantri."
                />

                <meta
                    name="robots"
                    content="noindex, nofollow"
                />

                <link
                    rel="canonical"
                    href="https://pushpabetfair.com/delete-jantri"
                />

                <link
                    rel="icon"
                    href="/favicon.ico"
                    type="image/x-icon"
                />

                <link
                    rel="icon"
                    type="image/png"
                    sizes="32x32"
                    href="/favicon-32x32.png"
                />

                <link
                    rel="icon"
                    type="image/png"
                    sizes="16x16"
                    href="/favicon-16x16.png"
                />

                <link
                    rel="apple-touch-icon"
                    sizes="180x180"
                    href="/apple-touch-icon.png"
                />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1.0"
                />

                <meta
                    property="og:title"
                    content="Delete Jantri | Remove Jantri Records | MatkaJantri"
                />

                <meta
                    property="og:description"
                    content="Delete Jantri records securely and manage your Matka satta data efficiently. Remove outdated or incorrect jantri entries easily on MatkaJantri."
                />

                <meta
                    property="og:type"
                    content="website"
                />

                <meta
                    property="og:url"
                    content="https://pushpabetfair.com/delete-jantri"
                />

                <meta
                    property="og:image"
                    content="https://app.matkajantri.com/JantriImage/Logo.png"
                />

            </Helmet>


            {/* ================================================= */}
            {/* Main Page */}
            {/* ================================================= */}

            <div className="w-100 fullpage">

                <div className="w-3">

                    {/* Back Button */}
                    <div className="back-top">

                        <i
                            className="fa-solid fa-chevron-left"
                            onClick={() => navigate("/game")}
                        ></i>

                    </div>


                    {/* Page Header */}
                    <div className="w-100 text-center d-flex">

                        <button
                            className="addFunds"
                            type="button"
                        >

                            <i className="fa-solid fa-trash"></i>

                            {" "}Delete Jantri

                        </button>

                    </div>


                    <div className="w-100 px-3">


                        {/* ===================================== */}
                        {/* Select Client */}
                        {/* ===================================== */}

                        <div className="mb-3 w-100">

                            <label className="form-label">

                                Select Client{" "}

                                <span
                                    style={{
                                        color: 'red'
                                    }}
                                >
                                    *
                                </span>

                            </label>


                            <select
                                className="form-control"
                                value={selectedClient}
                                onChange={(e) =>
                                    setSelectedClient(
                                        e.target.value
                                    )
                                }
                            >

                                <option value="">
                                    -- Select Client --
                                </option>


                                {/* All Clients */}
                                <option value="All Clients">
                                    All Clients
                                </option>


                                {/* User Clients */}
                                {sessionDetail?.user_clients?.map(
                                    (client, index) => (

                                        <option
                                            key={index}
                                            value={client}
                                        >
                                            {client}
                                        </option>

                                    )
                                )}

                            </select>

                        </div>


                        {/* ===================================== */}
                        {/* Select Game */}
                        {/* ===================================== */}

                        <div className="mb-3 w-100">

                            <label className="form-label">

                                Select Game{" "}

                                <span
                                    style={{
                                        color: 'red'
                                    }}
                                >
                                    *
                                </span>

                            </label>


                            <select
                                className="form-control"
                                value={selectedGame}
                                onChange={(e) =>
                                    setSelectedGame(
                                        e.target.value
                                    )
                                }
                            >

                                <option value="">
                                    -- Select Game --
                                </option>


                                {/* All Games */}
                                <option value="All Games">
                                    All Games
                                </option>


                                {/* User Games */}
                                {sessionDetail?.user_games?.map(
                                    (game, index) => (

                                        <option
                                            key={index}
                                            value={game}
                                        >
                                            {game}
                                        </option>

                                    )
                                )}

                            </select>

                        </div>


                        {/* ===================================== */}
                        {/* Delete Button */}
                        {/* ===================================== */}

                        <div className="text-center">

                            <button
                                type="button"
                                className="submit-btn support-btn"
                                onClick={handleDelete}
                            >
                                Delete Jantri
                            </button>

                        </div>

                    </div>

                </div>

            </div>


            {/* ================================================= */}
            {/* Custom Delete Confirmation Modal */}
            {/* ================================================= */}

            {showDeleteConfirm && (

                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,

                        backgroundColor:
                            'rgba(0, 0, 0, 0.65)',

                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',

                        zIndex: 9999,

                        padding: '20px'
                    }}
                >

                    <div
                        style={{
                            backgroundColor: '#fff',

                            width: '100%',
                            maxWidth: '400px',

                            borderRadius: '12px',

                            padding: '25px',

                            textAlign: 'center',

                            boxShadow:
                                '0 10px 40px rgba(0, 0, 0, 0.3)'
                        }}
                    >

                        {/* Warning Icon */}
                        <div
                            style={{
                                fontSize: '45px',
                                color: '#ff4d4d',
                                marginBottom: '10px'
                            }}
                        >

                            <i className="fa-solid fa-triangle-exclamation"></i>

                        </div>


                        {/* Title */}
                        <h3
                            style={{
                                marginBottom: '12px',
                                color: '#222'
                            }}
                        >
                            Delete All Records?
                        </h3>


                        {/* Message */}
                        <p
                            style={{
                                color: '#666',
                                marginBottom: '25px',
                                lineHeight: '1.6'
                            }}
                        >

                            You have selected{' '}

                            <strong>
                                All Clients
                            </strong>

                            {' '}and{' '}

                            <strong>
                                All Games
                            </strong>

                            .

                            <br />

                            Are you sure you want to delete
                            all records?

                        </p>


                        {/* Buttons */}
                        <div
                            style={{
                                display: 'flex',
                                gap: '10px',
                                justifyContent: 'center'
                            }}
                        >

                            {/* No */}
                            <button
                                type="button"
                                onClick={() =>
                                    setShowDeleteConfirm(false)
                                }
                                style={{
                                    padding: '10px 25px',

                                    border:
                                        '1px solid #ccc',

                                    borderRadius: '6px',

                                    backgroundColor: '#fff',

                                    color: '#333',

                                    cursor: 'pointer'
                                }}
                            >
                                No
                            </button>


                            {/* Yes */}
                            <button
                                type="button"
                                onClick={performDelete}
                                style={{
                                    padding: '10px 25px',

                                    border: 'none',

                                    borderRadius: '6px',

                                    backgroundColor:
                                        '#ff4d4d',

                                    color: '#fff',

                                    cursor: 'pointer'
                                }}
                            >
                                Yes, Delete
                            </button>

                        </div>

                    </div>

                </div>

            )}

        </DepositCss>
    );
}


